<template>
  <div class="evaluation-item" :class="direction">
    <div class="evaluation-item__label">{{ title }}</div>
    <div class="evaluation-item__form">
      <slot>
      </slot>
    </div>
  </div>
</template>


<style lang="scss" >
.evaluation-item {
  display: grid;
  border-bottom: 1px solid var(--attendee-border-color);
  grid-template-columns: 1fr 2fr;
  //align-items: center;
  gap: var(--attendee-gap-lg);
  padding: var(--attendee-gap-md);

  @media (max-width: 640px) {
    padding: var(--attendee-gap-sm);
  }


  &.column{
    grid-template-columns: 1fr;
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }


  &__label {
    font-weight: 600;
    font-size: 14px;
    color: var(--attendee-text-primary-color);
  }

  &__form {

  }
}
</style>

<script>
export default {
  props: ['title', 'direction']
}
</script>